module.exports = __webpack_public_path__ + "img/pause-button.84f8a7de.png";